// services/fetchData.js
export async function fetchData(url) {
  try {
    const response = await fetch(url)
    if (!response.ok) throw new Error(`Failed to fetch data from ${url} - Status: ${response.status}`)
    return await response.json();
  } catch (error) {
    console.error('Error fetching data:', error.message)
    return error;
  }
}
